import React from "react";
import Typography from "@material-ui/core/Typography";

const CenteredCardTitle = ({ children }) => (
  <Typography component="h1" variant="h5">
    {children}
  </Typography>
);

export default CenteredCardTitle;
